// Salesman Mutations

export const updateFullSalesmanList = (state, payload) => {
  state.fullSalesmanList = payload
}

export const updateSalesmanList = (state, payload) => {
  state.salesmanList = payload
}

export const fetchSalesmanInfo = (state, payload) => {
  state.salesmanInfo = payload
}
